import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchBox from "../search/SearchBox";
import { deviceList } from "../../services/deviceService"

// 페이징1
import Pagination from '../base/Pagination';

export default function Device() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [devices, setDevices] = useState([]);
    /* 검색기능 부분 */
    const [keyword, setKeyword] = useState("");
    const [filteredList, setFilteredList] = useState(devices);
    const token = localStorage.getItem("token");

    //페이징2
    const pageFromUrl = Number(searchParams.get("page"));
    const currentPage = Number.isInteger(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1;
    const logsPerPage = 6;

    const changePage = (page) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set("page", String(page));
        setSearchParams(nextParams);
    };

    const handleSearch = () => {
        const trimmedKeyword = keyword.trim().toLowerCase();

        if (trimmedKeyword === "") {
            setFilteredList(devices);
        } else {
            const filtered = devices.filter(
                (device) =>
                    String(device.id ?? "").toLowerCase().includes(trimmedKeyword) ||
                    String(device.plug_name ?? "").toLowerCase().includes(trimmedKeyword) ||
                    String(device.address ?? "").toLowerCase().includes(trimmedKeyword)
            );
            setFilteredList(filtered);
        }
        changePage(1);
    };

    const handleReset = () => {
        setKeyword("");
        setFilteredList(devices);
        changePage(1);
    };
    /* 검색기능 부분 끝 */

    const handleClick = (device) => {
        navigate(`/device/${device.id}`, { state: { device } });
    };

    const getDeviceList = async () => {
        try {
            const data = await deviceList(token);
            if (!data.success) {
                alert(data.message);
                console.error("기기 디바이스 :", data);
                return;
            }
            console.log("기기 디바이스 목록:", data);
            setDevices(data.device);
            setFilteredList(data.device); // 여기서도 filteredList 업데이트
        } catch (error) {
            console.error("기기 디바이스 목록 불러오기 실패:", error);
        }
    };

    useEffect(() => {
        getDeviceList();
    }, []);

    const getStatusText = (status) => {
        return status === 1 || status === "1" ? "정상" : "비정상";
    };

    const getMatchedText = (status) => {
        return status === 1 || status === "1" ? "정상" : "비정상";
    };
    // const formatDate = (dateString) => {
    //     const date = new Date(dateString);
    //     return date.toLocaleString('ko-KR');
    // };

    // 페이징3
    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = filteredList.slice(indexOfFirstLog, indexOfLastLog); // filteredList 표 값이랑 맞추기
    const totalPages = Math.ceil(filteredList.length / logsPerPage);

    return (
        <div className="device">
            <h1>장비 관리</h1>
            <div className="device_box">
                <SearchBox 
                    keyword={keyword} 
                    onChange={(e) => setKeyword(e.target.value)} 
                    onSearch={handleSearch} 
                    onReset={handleReset} 
                />
                <div className="device_list">
                    <div className="table">
                        <table>
                            <thead>
                                <tr>
                                    <th scope="col">장비 ID</th>
                                    <th scope="col" style={{ width: "55px" }}>사용자</th>
                                    <th scope="col">설치유무</th>
                                    <th scope="col">설치위치</th>                                    
                                    <th scope="col">플러그 <br />상태</th>
                                    <th scope="col">스위치 <br />상태</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentLogs.map((device) => (
                                    <tr key={device.id} onClick={() => handleClick(device)} style={{ cursor: "pointer" }}>
                                        <td scope="row">{device.plug_id}</td>
                                        <td>{device.name || "-"}</td>
                                        
                                        <td>
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "70px",
                                                    padding: "5px 0",
                                                    borderRadius: "3px",
                                                    color: "white",
                                                    backgroundColor:
                                                        device.is_matched === 1 || device.is_matched === "1" ? "#1ba9ff" : "#ef4444",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {getMatchedText(device.is_matched)}
                                            </span>
                                        </td>
                                        <td>{device.address || "-"}</td>
                                        <td>
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "65px",
                                                    padding: "5px 0",
                                                    borderRadius: "3px",
                                                    color: "white",
                                                    backgroundColor:
                                                        device.plug_status === 1 || device.plug_status === "1" ? "#22c55e" : "#ef4444",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {getStatusText(device.plug_status)}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                style={{
                                                    display: "inline-block",
                                                    width: "65px",
                                                    padding: "5px 0",
                                                    borderRadius: "3px",
                                                    color: "white",
                                                    backgroundColor:
                                                        device.swich_status === 1 || device.swich_status === "1" ? "#22c55e" : "#ef4444",
                                                    textAlign: "center"
                                                }}
                                            >
                                                {getStatusText(device.swich_status)}
                                            </span>
                                        </td>                              
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* <div className="btn-group">
                    <button onClick={() => navigate("/device/new")} className='btncolor01'>등록</button>
                </div> */}
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={changePage}
                />
            </div>
        </div>
    );
}
